<template>
    <div class="rd-card rd-card--border-top rd-card--no-padding" :class="{'card__small': limitHeight}">
        <div class="card__inner card__inner-small" :class="{'card__inner--small': limitHeight}">
            <template v-if="this.$route.name === 'personalise-finance'">
                <h3 class="card__title" v-if="title">{{ title }}</h3>

                <p class="card__description" v-if="description">{{ description }}</p>

                <div class="card__price" v-if="price">
                    <p>Vehicle price from:</p>
                    <span class="configurator__price">{{ formattedPrice }}</span>
                </div>
            </template>

            <template v-else>
                <h3 class="card__title" v-if="title">{{ title }}</h3>

                <div class="card__price" v-if="price">
                    <p>Vehicle price from:</p>
                    <span class="configurator__price">{{ formattedPrice }}</span>
                </div>
                <br>
            </template>

            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        limitHeight: {
            default: true,
            required: false,
        },
        title: {
            type: String,
            required: false
        },
        description: {
            type: String,
            required: false
        },
        price: {
            type: [String, Number],
            required: false
        },
        isSmall: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        formattedPrice() {
            return Number(this.price).toLocaleString('en-GB', {style: 'currency', currency: 'GBP'});
        }
    }
}
</script>

<style lang="scss" scoped>
.card {
    box-shadow: 0px 11px 24px rgba(0, 0, 0, 0.07);
    border-radius: 10px;
    border-top: 5px solid #0293d6;
    margin-top: 12px;
    width: 100%;

    @media (min-width: 992px) {
        width: 100%;
        max-width: none;
    }

    &__price {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        border-bottom: 1px solid rgba(151, 151, 151, .3);
        margin-bottom: 10px;

        p {
            margin: 12px 0;
        }
    }

    &__inner {
        padding: 25px 15px;
        background-color: white;
        border-radius: 0 0 10px 10px;
        height: 100%;

        &--small {
            max-height: 55vh;
            overflow-y: scroll;
        }
    }

    &__title {
        font-size: 20px;
        line-height: 20px;
        font-weight: 700;
        color: #192A44;
    }

    &__description {
        font-size: 14px;
        color: #4A4A4A;
        line-height: 24px;
        margin-top: 10px;
        margin-bottom: 10px;
    }
}

</style>